import React from 'react';
import Order from '../../models/Order';
import Store from '../../models/Store';
import shallowCompare from '../../lib/shallowCompare';
import PaymentMethod from '../PaymentMethod';
import OrderItemTile, { PhotoPositions } from '../OrderItemTile';
import styles from './index.sass';

class OrderReceipt extends React.Component {
  static propTypes = {
    order: React.PropTypes.instanceOf(Order),
    store: React.PropTypes.instanceOf(Store),
    showHeader: React.PropTypes.bool
  };

  static defaultProps = {
    showHeader: true
  };

  static contextTypes = {
    getUserAgent: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  renderOrderItems(items, storeId) {
    return items.map(orderItem => {
      let props = {
        orderItem: orderItem,
        key: orderItem.id,
        storeId: storeId,
        showBuyAgainButton: false,
        showTotal: true,
        photoPosition: PhotoPositions.Left
      };
      return <OrderItemTile {...props} />;
    });
  }

  renderInvoiceItems(invoiceItems) {
    return invoiceItems.map((invoiceItem, index) => {
      let invoiceItemProps = {
        key: index,
        className: `${styles.invoiceItem} ${invoiceItem.name.toLowerCase()}`,
        style: {color: invoiceItem.color}
      };
      return (
        <li {...invoiceItemProps}>
          <span className={styles.left}>{invoiceItem.name}</span>
          <span className={styles.right}>{invoiceItem.value}</span>
        </li>
      );
    });
  }

  renderShippingInfo() {
    let { order, store } = this.props;
    let shippingAddress = order.shipping_address;
    let shippingMethod = order.shipping_method;

    if(shippingMethod.address_required) {
      return (
        <div className={styles.shippingInfo}>
          <p className={styles.label}>Shipping Address</p>
          <div className={styles.address}>
            {shippingAddress.name ? <p>{shippingAddress.name}</p> : null}
            <p>{shippingAddress.addr1}</p>
            {shippingAddress.addr2 ? <p>{shippingAddress.addr2}</p> : null}
            <p>{shippingAddress.city}, {shippingAddress.state} {shippingAddress.zip_code}</p>
          </div>
          <p className={styles.label}>Shipping Method</p>
          <p className={styles.shippingMethod}>{order.shipping_method.title}</p>
        </div>
      );
    }
    // Assume local pickup
    let storeAddress = store.address;
    return (
      <div className={styles.shippingInfo}>
        <p className={styles.label}>Pick Up At</p>
        <div className={styles.address}>
          {storeAddress.name ? <p>{storeAddress.name}</p> : null}
          <p>{storeAddress.addr1}</p>
          {storeAddress.addr2 ? <p>{storeAddress.addr2}</p> : null}
          <p>{storeAddress.city}, {storeAddress.state} {storeAddress.zip_code}</p>
        </div>
        <p className={styles.label}>Hours</p>
        {store.hours ? <p dangerouslySetInnerHTML={{__html: store.hours.replace(/\n/g, '<br/>')}} /> : null}
      </div>
    );
  }

  render() {
    let { order, store } = this.props;
    let { isMobile } = this.context.getUserAgent();
    let shippingAddress = order.shipping_address;
    let paymentMethodProps = {
      paymentMethod: order.payment_method,
      includeLeadingBullets: true
    };
    let header;
    if(this.props.showHeader) {
      header = (
        <div>
          <h1 className={styles.header}>Order Receipt</h1>
          <p className={styles.orderDetails}>{isMobile ? '' : 'Order: #'}{order.order_number} • {order.formatted_submitted_at}</p>
        </div>
      );
    }

    return (
      <div className={styles.orderReceipt}>
        {header}
        <div className={styles.items}>
          {this.renderOrderItems(order.items, order.store.id)}
        </div>
        <ul className={styles.invoice}>
          {this.renderInvoiceItems(order.invoice)}
          <li className={styles.paymentMethod}>
            <span className={styles.left}>Paid with</span>
            <span className={styles.right}><PaymentMethod {...paymentMethodProps} /></span>
          </li>
        </ul>
        <div className={styles.lowerSection}>
          {this.renderShippingInfo()}
          <div className={styles.supportInfo}>
            <p className={styles.label}>Support</p>
            <p className={styles.storeName}>{store.name}</p>
            <a className={styles.storeEmail} href={`mailto:${store.contact_email}`}>{store.contact_email}</a>
            <a className={styles.storePhone} href={`tel:${store.phone_href_format}`}>{store.phone_pretty}</a>
          </div>
        </div>
      </div>
    );
  }
}

export default OrderReceipt;



// WEBPACK FOOTER //
// banquet/components/OrderReceipt/index.js